var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dashboard-page bold tablec" }, [
    _c(
      "div",
      { staticClass: "d-flex flex-row" },
      [
        _c(
          "Widget",
          { staticClass: "shares-widget w-100 bg-transparent" },
          [
            _c("h4", [_vm._v("Manage behaviour awards")]),
            _vm._v(" "),
            _vm.isReceiving ? _c("Loader", { attrs: { size: 40 } }) : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group row" },
              [
                _c(
                  "label",
                  { staticClass: "col-md-2", attrs: { for: "awardAction" } },
                  [_vm._v("Select award")]
                ),
                _vm._v(" "),
                _c("v-select", {
                  staticClass: "col-md-5",
                  attrs: {
                    clearable: false,
                    id: "awardAction",
                    options: _vm.availableAwards
                  },
                  model: {
                    value: _vm.selectedAward,
                    callback: function($$v) {
                      _vm.selectedAward = $$v
                    },
                    expression: "selectedAward"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group row" },
              [
                _c(
                  "label",
                  { staticClass: "col-md-2", attrs: { for: "awardDateRange" } },
                  [_vm._v("Date range")]
                ),
                _vm._v(" "),
                _c("v-date-picker", {
                  staticClass: "col-md-5",
                  attrs: { mode: "range", id: "awardDateRange" },
                  model: {
                    value: _vm.calendarData,
                    callback: function($$v) {
                      _vm.calendarData = $$v
                    },
                    expression: "calendarData"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm._l(_vm.errorsList, function(error) {
              return _c(
                "b-alert",
                {
                  key: error,
                  staticClass: "alert-sm w-25",
                  attrs: { variant: "danger", show: _vm.errorsList.length > 0 }
                },
                [_vm._v("\n            " + _vm._s(error) + "\n        ")]
              )
            }),
            _vm._v(" "),
            _c(
              "b-button",
              {
                staticClass: "mt-3 mb-3",
                attrs: { variant: "success" },
                on: {
                  click: function($event) {
                    return _vm.onAwardSelect()
                  }
                }
              },
              [_c("span", [_vm._v("Add award")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "list-group list-group-lg" },
              _vm._l(_vm.awards, function(award) {
                return _c(
                  "div",
                  {
                    key: award.id,
                    staticClass: "list-group-item display-flex",
                    staticStyle: { "align-items": "center" },
                    attrs: { href: "#" }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "thumb-xl mr",
                        staticStyle: { width: "100px" }
                      },
                      [
                        _c("img", {
                          attrs: { src: award.downloadUrl, alt: "..." }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticStyle: { width: "70%" } }, [
                      _c("h4", {}, [
                        _c("i", {
                          staticClass: "fa fa-circle",
                          class:
                            "text-" + (award.public ? "success" : "inverse")
                        }),
                        _vm._v(
                          "\n                        " +
                            _vm._s(award.title) +
                            "\n                    "
                        )
                      ]),
                      _vm._v(" "),
                      _c("h6", [_vm._v(_vm._s(award.description))]),
                      _vm._v(" "),
                      _c("small", { staticClass: "text-muted" }, [
                        _vm._v(
                          _vm._s(_vm.formatDate(award.startDate)) +
                            " - " +
                            _vm._s(_vm.formatDate(award.endDate))
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "ml-auto" },
                      [
                        _c("span", {
                          staticClass: "glyphicon glyphicon-remove icon-button",
                          attrs: { id: "popoverDeleteAward_" + award.id }
                        }),
                        _vm._v(" "),
                        _c(
                          "b-popover",
                          {
                            staticClass: "popover-danger",
                            attrs: {
                              triggers: "click",
                              target: "popoverDeleteAward_" + award.id,
                              show: _vm.awardPopover[award.id],
                              placement: "top"
                            },
                            on: {
                              "update:show": function($event) {
                                return _vm.$set(
                                  _vm.awardPopover,
                                  award.id,
                                  $event
                                )
                              }
                            }
                          },
                          [
                            _c("template", { slot: "title" }, [
                              _c("div", { staticClass: "px-5" }, [
                                _vm._v(
                                  "Are you sure you want to remove this award?"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "px-5 d-flex justify-content-center"
                              },
                              [
                                _c(
                                  "b-button-toolbar",
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          variant: "success",
                                          size: "xs"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeAward(award)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    Yes\n                                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          variant: "danger",
                                          size: "xs"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.closePopover(award.id)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    No\n                                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _c(
                  "b-button-toolbar",
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "success" },
                        on: {
                          click: function($event) {
                            return _vm.saveAwardsForBehaviour()
                          }
                        }
                      },
                      [
                        _vm.isUpdating
                          ? _c("Loader")
                          : _c("span", [_vm._v("Save")])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "default" },
                        on: {
                          click: function($event) {
                            return _vm.goBack()
                          }
                        }
                      },
                      [_vm._v("\n                    Back\n                ")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }